
const downloadWrapper = {
  "bodyCopy": "AT&T has the best wireless network according to America’s biggest test.*",
  "primaryArea": {
    "heading": "It's all in the app",
    "eyebrow": "myAT&T APP",    
    "copy": "Get everything you need to manage your AT&T account and check out your benefits,  right at your fingertips.",  
    "downloadSection": {
      "heading": "Download the myAT&T app today!",
      "copy": "AT&T wireless customers can text MYATT to 8758 or click below.",
      "disclaimer":"myAT&T app: Eligible wireless, TV and Internet customers only; Data/messaging rates may apply for app download and usage. Req’s compatible device with iOS 10 and higher Android™ 5.0 and higher.",
      "apps": [
          {
              "icon": "appStore",
              "url": "https://apps.apple.com/us/app/myat-t/id309172177",
              "id": "appStore",
              "altText": "Download on the App Store"
          }, {
              "icon": "googlePlay",
              "id": "googlePlay",
              "url": "https://play.google.com/store/apps/details?id=com.att.myWireless",
              "altText": "Get it on Google Play"
          }
      ],
    }
  },
  "cta": {
    "label": "Explore",
    "id": "explore",
    "href": "https://www.att.com/",
    "color": "primary",
    round: true
  },
  "disclaimer": "*Based on GSW OneScore Sept. 2018. Excludes crowd sourced studies."
}

module.exports = downloadWrapper;
